import { useQuery } from 'data-fetching-client';
import { GET_PRODUCTS_QUERY } from '../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc.dfc.new';
import { GET_PRODUCTS_QUERY as GET_PRODUCTS_QUERY_NO_AUTH } from '../../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc.dfc.new';
import { useIsInAppAuth } from './useUserInfo';
const useProductDetailsQuery = (isAppAuth = false) => isAppAuth ? GET_PRODUCTS_QUERY : GET_PRODUCTS_QUERY_NO_AUTH;
export const useProductDetails = ({
  productApiName
}) => {
  var _productDetailsQuery$;
  const isAppAuth = useIsInAppAuth();
  const query = useProductDetailsQuery(isAppAuth);
  const productDetailsQuery = useQuery(query, {
    variables: {
      productApiNames: [productApiName]
    }
  });
  const productDetails = (_productDetailsQuery$ = productDetailsQuery.data) === null || _productDetailsQuery$ === void 0 ? void 0 : _productDetailsQuery$.result.productsByName[productApiName];
  const loading = productDetailsQuery.loading;
  return {
    productDetails,
    loading
  };
};
export const useIncludedCoreSeats = ({
  productApiName
}) => {
  var _packagedQuantities$f;
  const {
    productDetails
  } = useProductDetails({
    productApiName
  });
  const packagedQuantities = productDetails === null || productDetails === void 0 ? void 0 : productDetails.packagedQuantities;
  const includedCoreSeats = packagedQuantities === null || packagedQuantities === void 0 || (_packagedQuantities$f = packagedQuantities.find(packagedQuantity => packagedQuantity.name === 'CORE_SEAT')) === null || _packagedQuantities$f === void 0 ? void 0 : _packagedQuantities$f.quantity;
  return includedCoreSeats;
};
export const useIncludedSalesSeats = ({
  productApiName
}) => {
  var _packagedQuantities$f2;
  const {
    productDetails
  } = useProductDetails({
    productApiName
  });
  const packagedQuantities = productDetails === null || productDetails === void 0 ? void 0 : productDetails.packagedQuantities;
  const includedSalesSeats = packagedQuantities === null || packagedQuantities === void 0 || (_packagedQuantities$f2 = packagedQuantities.find(packagedQuantity => packagedQuantity.name === 'SALES_SEAT')) === null || _packagedQuantities$f2 === void 0 ? void 0 : _packagedQuantities$f2.quantity;
  return includedSalesSeats;
};
export const useIncludedServiceSeats = ({
  productApiName
}) => {
  var _packagedQuantities$f3;
  const {
    productDetails
  } = useProductDetails({
    productApiName
  });
  const packagedQuantities = productDetails === null || productDetails === void 0 ? void 0 : productDetails.packagedQuantities;
  const includedServiceSeats = packagedQuantities === null || packagedQuantities === void 0 || (_packagedQuantities$f3 = packagedQuantities.find(packagedQuantity => packagedQuantity.name === 'SERVICE_SEAT')) === null || _packagedQuantities$f3 === void 0 ? void 0 : _packagedQuantities$f3.quantity;
  return includedServiceSeats;
};
export const useIncludedCommerceSeats = ({
  productApiName
}) => {
  var _packagedQuantities$f4;
  const {
    productDetails
  } = useProductDetails({
    productApiName
  });
  const packagedQuantities = productDetails === null || productDetails === void 0 ? void 0 : productDetails.packagedQuantities;
  const includedCommerceSeats = packagedQuantities === null || packagedQuantities === void 0 || (_packagedQuantities$f4 = packagedQuantities.find(packagedQuantity => packagedQuantity.name === 'COMMERCE_SEAT')) === null || _packagedQuantities$f4 === void 0 ? void 0 : _packagedQuantities$f4.quantity;
  return includedCommerceSeats;
};
export const useIsCoreSeatSku = ({
  productApiName
}) => {
  const {
    productDetails
  } = useProductDetails({
    productApiName
  });
  return (productDetails === null || productDetails === void 0 ? void 0 : productDetails.skuCategoryName) === 'CORE_PLATFORM_SEATS';
};
export const useProductDetailsForArray = ({
  productApiNames
}) => {
  var _productDetailsQuery$2;
  const isAppAuth = useIsInAppAuth();
  const query = useProductDetailsQuery(isAppAuth);
  const productDetailsQuery = useQuery(query, {
    variables: {
      productApiNames
    }
  });
  const loading = productDetailsQuery.loading;
  const productDetails = (_productDetailsQuery$2 = productDetailsQuery.data) === null || _productDetailsQuery$2 === void 0 ? void 0 : _productDetailsQuery$2.result;
  return {
    productDetails,
    loading
  };
};
export const useHasProductInProductDetails = ({
  productApiName
}) => {
  const {
    productDetails,
    loading
  } = useProductDetails({
    productApiName
  });
  return {
    hasProduct: !!productDetails,
    loading
  };
};
export const useHasAnyCoreSeatsInProductDetails = () => {
  var _productDetails$produ;
  const {
    productDetails,
    loading
  } = useProductDetailsForArray({
    productApiNames: ['core-seats-starter', 'core-seats-professional', 'core-seats-enterprise']
  });
  const hasAnyCoreSeats = Object.keys((_productDetails$produ = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productsByName) !== null && _productDetails$produ !== void 0 ? _productDetails$produ : {}).length > 0;
  return {
    hasAnyCoreSeats,
    loading
  };
};
export const useHasAnySuiteBundlesInProductDetails = () => {
  var _productDetails$produ2;
  const {
    productDetails,
    loading
  } = useProductDetailsForArray({
    productApiNames: ['crm-suite-starter-bundle', 'crm-suite-professional-bundle', 'crm-suite-enterprise-bundle']
  });
  const hasAnySuiteBundles = Object.keys((_productDetails$produ2 = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productsByName) !== null && _productDetails$produ2 !== void 0 ? _productDetails$produ2 : {}).length > 0;
  return {
    hasAnySuiteBundles,
    loading
  };
};